export default function cleanReference(reference) {
  if (!reference) {
    return "";
  }
  if (reference.match(new RegExp("^[ivxlcdm]+$", "i"))) {
    return reference;
  }
  return reference.replace(/\.meaning/g, "").replace(/^[A-Za-z]{3,}/, "");
}
